import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

function rowDiffers(row, columns) {
  if (!row.value || columns.length < 2) return false;
  const first = row.value(columns[0].subject);
  return columns.some((c) => !Object.is(row.value(c.subject), first));
}
function CompareView({
  columns,
  rows,
  highlightDifferences = true,
  stickyLabels = true,
  className,
  emptyState
}) {
  if (columns.length === 0 || rows.length === 0) {
    return /* @__PURE__ */ jsx(Fragment, { children: emptyState ?? null });
  }
  let lastGroup;
  return /* @__PURE__ */ jsx("div", { className: cn("w-full overflow-x-auto rounded-lg border", className), children: /* @__PURE__ */ jsxs("table", { className: "w-full border-collapse text-sm", children: [
    /* @__PURE__ */ jsx("thead", { children: /* @__PURE__ */ jsxs("tr", { className: "border-b bg-muted/40", children: [
      /* @__PURE__ */ jsx(
        "th",
        {
          className: cn(
            "px-4 py-2 text-left font-medium text-muted-foreground",
            stickyLabels && "sticky left-0 bg-muted/40"
          )
        }
      ),
      columns.map((col) => /* @__PURE__ */ jsx("th", { className: "px-4 py-2 text-left font-semibold", children: col.header }, col.id))
    ] }) }),
    /* @__PURE__ */ jsx("tbody", { children: rows.map((row) => {
      const differs = highlightDifferences && rowDiffers(row, columns);
      const showGroup = row.group && row.group !== lastGroup;
      lastGroup = row.group ?? lastGroup;
      return /* @__PURE__ */ jsxs(React.Fragment, { children: [
        showGroup && /* @__PURE__ */ jsx("tr", { className: "border-b bg-muted/20", children: /* @__PURE__ */ jsx(
          "td",
          {
            colSpan: columns.length + 1,
            className: "px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground",
            children: row.group
          }
        ) }),
        /* @__PURE__ */ jsxs("tr", { className: "border-b last:border-0", children: [
          /* @__PURE__ */ jsx(
            "td",
            {
              className: cn(
                "px-4 py-2 font-medium text-muted-foreground",
                stickyLabels && "sticky left-0 bg-background"
              ),
              children: row.label
            }
          ),
          columns.map((col) => /* @__PURE__ */ jsx(
            "td",
            {
              className: cn(
                "px-4 py-2 tabular-nums",
                differs && "bg-risk-medium/10 font-medium text-foreground"
              ),
              children: row.render(col.subject, col)
            },
            col.id
          ))
        ] })
      ] }, row.id);
    }) })
  ] }) });
}

export { CompareView };
//# sourceMappingURL=chunk-HG4TIKYQ.js.map
//# sourceMappingURL=chunk-HG4TIKYQ.js.map